import { v4 as uuidv4 } from 'uuid';

function generateRequestId() {
  return uuidv4();
}

export function getDefaultHeaderObj() {
  return {
    'cache-control': 'no-cache',
    'content-type': 'application/json',
    'x-ms-lastwritetime': 'Max',
    'x-ms-applicationname': 'bingadsweb',
    'x-ms-requestid': generateRequestId(),
  };
}
